import React from "react";
import benefits from "../../assets/db_images/benifits.png";
import db from "../../assets/db_images/database-storage.png";
import performance from "../../assets/db_images/good-feedback.png";
import optimized from "../../assets/db_images/seo.png";
import migration from "../../assets/db_images/migration.png";

const Benefits = () => {
  return (
    <div className="mt-10">
      <p className="text-center font-notosans text-2xl sm:text-4xl font-bold text-[#333e49]">
        Benefits of Database Migration & Modernization Service
      </p>
      <div className="flex flex-col items-center justify-between mt-5">
        <div className="flex w-full px-5 sm:px-28 justify-between">
          <p className="font-notosans flex flex-col items-center gap-5 w-full text-center text-sm sm:text-lg">
            <img src={db} className="w-8 sm:w-14" />Database/object fragmentation can be alleviated</p>
          <p className="font-notosans flex flex-col items-center gap-5 w-full text-center text-sm sm:text-lg"><img src={performance} className="w-8 sm:w-14" />Better performance and database management</p>
        </div>

        <div className="flex w-full px-5 sm:px-28 justify-between mt-5">
          <p className="font-notosans flex flex-col items-center gap-5 w-full text-center text-sm sm:text-lg"><img src={optimized} className="w-8 sm:w-14" />Optimized database and resource usages</p>
          <p className="font-notosans flex flex-col items-center gap-5 w-full text-center text-sm sm:text-lg"><img src={migration} className="w-8 sm:w-14" />Migration with minimum downtime and less impact on business</p>
        </div>
      </div>
    </div>
  );
};

export default Benefits;
